import {
    Button,
    Card,
    Divider,
    Empty,
    Flex,
    List,
    Select,
    Spin,
    Tabs,
    Tag,
    TreeSelect
} from 'antd';
import {SwapOutlined} from '@ant-design/icons';
import {FullBook} from "../../../../../shared/types/api";
import IconVolumeUp from "../../../../elements/svg_icons/IconVolumeUp";
import Constants from "../../../../../const/Constants";
import TabPane from "antd/es/tabs/TabPane";
import BookmarksTab from "./BookmarksTab";


export const BookTabs: React.FC<{
    selectedText?: string,
    disableSelected: boolean,
    playWord: () => void,
    translating: boolean,
    disableTranslated: boolean,
    translatedText: string,
    disableAdd: boolean,
    loadingWord: boolean,
    wordListsIsLoading: boolean,
    addToDictionary: () => void,
    selectedList: any,
    treeCardLists: any,
    changeWordList: (id: any) => void,
    book?: FullBook,
    sideOneLang: string,
    sideTwoLang: string,
    setSideOneLang: (v: string) => void,
    setSideTwoLang: (v: string) => void
    readChars:number,
    openBookMark: (offset: number) => void
}> = (
    {
        selectedText,
        disableSelected,
        playWord,
        translating,
        disableTranslated,
        translatedText,
        disableAdd,
        loadingWord,
        addToDictionary,
        selectedList,
        changeWordList,
        treeCardLists,
        wordListsIsLoading,
        book,
        sideOneLang,
        sideTwoLang,
        setSideOneLang,
        setSideTwoLang,
        readChars,
        openBookMark
    }) => {


    return (
        <Tabs defaultActiveKey="translation">
            <TabPane tab="Перевод" key="translation">
                <Flex vertical gap={8} style={{margin: 6, alignItems: "center"}}>
                    <Select onChange={setSideOneLang} value={sideOneLang} style={{width: "100%"}}>
                        {Constants.LANGUAGES.map((el) => (
                            <Select.Option key={el.id} value={el.id}>
                                {el.description}
                            </Select.Option>
                        ))}
                    </Select>
                    <SwapOutlined style={{fontSize: 20, color: "#555"}}/>
                    <Select onChange={setSideTwoLang} value={sideTwoLang} style={{width: "100%"}}>
                        {Constants.LANGUAGES.map((el) => (
                            <Select.Option key={el.id} value={el.id}>
                                {el.description}
                            </Select.Option>
                        ))}
                    </Select>
                </Flex>
                {selectedText ? (
                    <Card
                        size="small"
                        title={<span>Выделено <Tag
                            color={disableSelected ? "red" : "blue"}>{selectedText.length} символов</Tag></span>}
                        style={{backgroundColor: '#f0f5ff', marginTop: 12}}
                    >
                        <p style={{fontStyle: 'italic', fontSize: '15px'}}>
                            "{selectedText}"
                        </p>
                        <IconVolumeUp className={'pointer-cursor'} onClick={playWord} width='25' height='25'
                                      stroke={'black'}/>

                        <Divider style={{margin: '12px 0'}}/>
                        {translating ? (
                            <Spin tip="Перевод..."/>
                        ) : (
                            <>
                                <p>
                                    <em style={{color: '#999'}}>Перевод: <Tag
                                        color={disableTranslated ? "red" : "blue"}>{translatedText.length} символов</Tag></em><br/>
                                    <strong>{translatedText}</strong>
                                </p>
                                {disableAdd && (
                                    <p style={{color: 'red', marginTop: 8}}>
                                        {`⚠️ Превышено ограничение в ${Constants.MAX_CARD_SIDE_LENGTH} символов. Добавление в словарь недоступно.`}
                                    </p>
                                )}
                                <TreeSelect
                                    value={selectedList}
                                    treeLine={true}
                                    treeDataSimpleMode
                                    style={{marginTop: 12, width: '100%'}}
                                    dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                                    placeholder='Выберите список карточек'
                                    onChange={changeWordList}
                                    treeData={treeCardLists}
                                    loading={wordListsIsLoading}
                                />
                                <Button disabled={disableAdd} loading={loadingWord} type={'primary'}
                                        onClick={addToDictionary} block
                                        style={{marginTop: 12}}>
                                    Добавить в словарь
                                </Button>
                            </>
                        )}
                    </Card>
                ) : (
                    <Empty description="Выделите текст для перевода"/>
                )}
            </TabPane>

            <TabPane tab="Закладки" key="bookmarks">
                <BookmarksTab readChars={readChars} openBookMark={openBookMark}/>
            </TabPane>

            <TabPane tab="Содержание" key="toc">
                {book && book?.chapters.length > 0 && <List
                    size="small"
                    bordered
                    dataSource={book?.chapters}
                    renderItem={(item) => <List.Item>{item.title}</List.Item>}
                />}
            </TabPane>

        </Tabs>
    )
}